import React, { useContext, useEffect, useState } from "react";
import { Modal, Form } from "react-bootstrap";
import { DocumentMasterContext } from ".";

import { toast } from "react-toastify";
import { validateTestimonial } from "./TestimonialPanel";
import TestimonialServices from "../../../services/API/Testimonial";

import Multiselect from "multiselect-react-dropdown";
import "../../../styles/documentMaster/addDoc.css";
import { multiSelectStyle } from "../../../components/CreateExecutive/MultiSelectStyle";
export const availableFormats = ["PDF", "IMG", "JPEG", "SVG"];
export const all_rating = [0.5,1,1.5,2,2.5,3,3.5,4,4.5,5]; 
export default function AddTestimonial({
  editData,
  setEdit,
  refetch,
  filter,
  clearFilter,
}) {
  const { show, setShow } = useContext(DocumentMasterContext);
  const [name, setName] = useState(null);
  const [company_name, setCompanyName] = useState(null);
  const [text, setText] = useState(null);
  const [rating, setRating] = useState(null);
  const [file, setFile] = useState(null);

  useEffect(() => {
    if (editData) {
      setName(editData?.name);
      setCompanyName(editData?.company_name);
      setText(editData?.text);
      setRating(editData?.rating);
      setFile(editData?.image);
    }
  }, [editData]);
  const update = async () => {
    const payload = {
      name: name,
      company_name : company_name,
      text : text,
      rating : rating,
      file : file
    };
    const error = validateTestimonial(payload);
    if (error) {
      toast.error(error);
      return;
    }
    try {
      const response = await TestimonialServices.updateTestimonial(
        editData?.id,
        payload
      );
      if (response) {
        toast.success("Testimonial updated successfully");
        refetch();
        setEdit(null);
        // clearFilter();
        handleHide();
      }
    } catch (e) {
      toast.error(e);
    }
  };
  const add = async () => {
    const payload = {
      name: name,
      company_name : company_name,
      text : text,
      rating : rating,
      file : file
    };

    const error = validateTestimonial(payload);
    if (error) {
      toast.error(error);
      return;
    }

    try {
      const response = await TestimonialServices.addTestimonial(payload);
      if (response) {
        toast.success("Testimonial created successfully");
        refetch();
        clearFilter();
        handleHide();
      }
    } catch (e) {
      toast.error(e.message);
    }
  };
  const submitForm = () => {
    if (editData) {
      update();
    } else {
      add();
    }
  };
  const handleHide = () => {
    setShow(null);
    setEdit(null);
    setName(null);
    setCompanyName(null);
    setText(null);
    setRating(null);
    setFile(null);

  };


  return (
    <Modal show={show === "document"} onHide={handleHide} animation={false}>
      <Modal.Header closeButton>
        <h3 className="modal-title">
          {editData ? "Edit Testimonial" : "Add Testimonial"}
        </h3>
      </Modal.Header>
      <Modal.Body>
        <div className="form-group padding-top-10">
          <label htmlFor="tags">
            {" "}
            Name<span style={{ color: "red" }}> *</span>
          </label>
          <input
            type="text"
            value={name}
            className="form-control"
            placeholder="Enter Name"
            onChange={(e) => setName(e.target.value)}
          />
        </div>
        <div className="form-group padding-top-10">
          <label htmlFor="tags">
            {" "}
            Company Name
          </label>
          <input
            type="text"
            value={company_name}
            className="form-control"
            placeholder="Enter Company Name"
            onChange={(e) => setCompanyName(e.target.value)}
          />
        </div>
        <div className="form-group padding-top-10">
          <label htmlFor="tags">
            {" "}
            Description<span style={{ color: "red" }}> *</span>
          </label>
          <textarea
            type="text"
            value={text}
            className="form-control"
            placeholder="Enter Description"
            onChange={(e) => setText(e.target.value)}
          ></textarea>
        </div>
        <div className="form-group padding-top-10">
          <section className="col">
            <label className="">
              Rating
              <span style={{ color: "red" }}> *</span>
            </label>
            <Form.Group>
              <Form.Control
                as="select"
                className="py-2"
                style={{ fontSize: "12px",boxSizing:'border-box',paddingLeft:"10px" }}
                value={rating}
                onChange={(e) => setRating(e.target.value)}
              >
                <option value="" style={{ fontSize: "12px" }}>
                  Select Rating
                </option>
                {all_rating?.map((item) => {
                  return (<option
                    value={item}
                    style={{ fontSize: "12px" }}
                  >
                    {item}
                  </option>)
                })}
              </Form.Control>
            </Form.Group>
          </section>
        </div>
        <div className="form-group padding-top-10">
          <label htmlFor="tags"> Select file<span style={{ color: "red" }}> *</span></label>
          <div className="d-flex">
            <input
              type="file"
              className={
                typeof file === "string" ? `form-control file1` : `form-control`
              }
              placeholder="Name"
              onChange={(e) => setFile(e.target.files[0])}
            />
            {typeof file === "string" && (
              <input
                type="text"
                className="form-control file2"
                // disabled
                value={typeof file === "string" ? file : ""}
              />
            )}
          </div>

          <div className="note">
            <strong>Note:</strong> Accepted format : PNG,JPEG,SVG,WEBP,AVIF Max size :2MB
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          className="btn button_new_success"
          onClick={submitForm}
        >
          Save
        </button>
      </Modal.Footer>
    </Modal>
  );
}
